import { lazy, Suspense, useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { ShopProvider } from "@/lib/shop";
import SiteLayout from "@/components/site/SiteLayout";
import { Loading } from "@/components/site/States";
import Home from "@/pages/Home";
import Catalog from "@/pages/Catalog";
import Categories from "@/pages/Categories";
import ProductDetail from "@/pages/ProductDetail";
import PoCorner from "@/pages/PoCorner";
import Promo from "@/pages/Promo";
import Favorites from "@/pages/Favorites";
import Cart from "@/pages/Cart";
import { Guide, About, Contact, Policy } from "@/pages/InfoPages";
import NotFound from "@/pages/NotFound";
import SellLanding from "@/pages/collection/SellLanding";
import SubmitPage from "@/pages/collection/SubmitForm";
import CollectionTrack from "@/pages/collection/Track";
import CollectionGallery from "@/pages/collection/Gallery";
import Nota from "@/pages/Nota";
import QrisPay from "@/pages/QrisPay";
import TrackOrder from "@/pages/TrackOrder";

const AdminApp = lazy(() => import("@/admin/AdminApp"));

function ScrollTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function App() {
  return (
    <ShopProvider>
      <BrowserRouter>
        <ScrollTop />
        <Routes>
          <Route path="/admin/*" element={<Suspense fallback={<Loading />}><AdminApp /></Suspense>} />
          <Route element={<SiteLayout />}>
            <Route path="/" element={<Home />} />
            <Route path="/katalog" element={<Catalog />} />
            <Route path="/kategori" element={<Categories />} />
            <Route path="/kategori/:slug" element={<Catalog />} />
            <Route path="/produk/:slug" element={<ProductDetail />} />
            <Route path="/pre-order" element={<PoCorner />} />
            <Route path="/pre-order/:slug" element={<ProductDetail poMode />} />
            <Route path="/promo" element={<Promo />} />
            <Route path="/favorit" element={<Favorites />} />
            <Route path="/keranjang" element={<Cart />} />
            <Route path="/panduan" element={<Guide />} />
            <Route path="/lacak-pesanan" element={<TrackOrder />} />
            <Route path="/jual-koleksi" element={<SellLanding />} />
            <Route path="/koleksi-titipan" element={<CollectionGallery />} />
            <Route path="/jual-koleksi/:kind" element={<SubmitPage />} />
            <Route path="/collection/track" element={<CollectionTrack />} />
            <Route path="/nota/:no" element={<Nota />} />
            <Route path="/bayar/:no" element={<QrisPay />} />
            <Route path="/tentang" element={<About />} />
            <Route path="/kontak" element={<Contact />} />
            <Route path="/kebijakan-privasi" element={<Policy k="policy_privacy" title="Kebijakan Privasi" />} />
            <Route path="/syarat-ketentuan" element={<Policy k="policy_terms" title="Syarat dan Ketentuan" />} />
            <Route path="/kebijakan-pengiriman" element={<Policy k="policy_shipping" title="Kebijakan Pengiriman dan Pembatalan" />} />
            <Route path="*" element={<NotFound />} />
          </Route>
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </ShopProvider>
  );
}

export default App;
